module.exports = __webpack_public_path__ + "static/media/dash.bc8cf8c8.png";